console.log(`
 %c$$$$$$\\                           $$\\                                 %c$$\\%c
$$ ___$$\\                          $$ |                                %c$$ |%c 
\\_/   $$ | $$$$$$$\\ $$$$$$\\   $$$$$$$ |%c$$$$$$$\\   $$$$$$\\  $$\\   $$\\ $$$$$$\\%c
  $$$$$ / $$  _____|\\____$$\\ $$  __$$ |%c$$  __$$\\ $$  __$$\\ \\$$\\ $$  |\\_$$  _|%c
  \\___$$\\ $$ /      $$$$$$$ |$$ /  $$ |%c$$ |  $$ |$$$$$$$$ | \\$$$$  /   $$ |%c
$$\\   $$ |$$ |     $$  __$$ |$$ |  $$ |%c$$ |  $$ |$$   ____| $$  $$<    $$ |$$\\%c
\\$$$$$$  |\\$$$$$$$\\\\$$$$$$$ |\\$$$$$$$ |%c$$ |  $$ |\\$$$$$$$\\ $$  /\\$$\\   \\$$$$  |%c
 \\______/  \\_______|\\_______| \\_______|%c\\__|  \\__| \\_______|\\__/  \\__|   \\____/
`, 'color: #000', 'color: #e45a3f', 'color: #000', 'color: #e45a3f', 'color: #000', 'color: #e45a3f', 'color: #000', 'color: #e45a3f', 'color: #000', 'color: #e45a3f', 'color: #000', 'color: #e45a3f', 'color: #000', 'color: #e45a3f', 'color: #000', 'color: #e45a3f');



// WEBPACK FOOTER //
// ./src/chunks/consoleCredits.js